import React from 'react';
// Constants
import {
  CONTACT_PAGE_URL,
  TRIBUTE_PAGE_URL,
  SESSIONS_PAGE_URL,
  GALLERY_PAGE_URL,
} from '../../utils/Routes';
import { CompanyName } from '../../utils/Constants';
import { Link } from 'react-router-dom';

function CallToActionOne() {
  const buttons = [
    {
      text: 'Spoil Me',
      link: TRIBUTE_PAGE_URL,
      ariaLabel: `Send a tribute to ${CompanyName}`,
    },
    {
      text: 'My Services',
      link: SESSIONS_PAGE_URL,
      ariaLabel: `Learn about submission to ${CompanyName}`,
    },
    {
      text: 'Contact Me',
      link: CONTACT_PAGE_URL,
      ariaLabel: `Book a session with ${CompanyName}`,
    },
    {
      text: 'Gallery',
      link: GALLERY_PAGE_URL,
      ariaLabel: `Explore ${CompanyName}’s images`,
    },
  ];

  return (
    <section className='grid h-fit px-8 sm:px-10 md:px-20 lg:px-32'>
      <div className='grid neon-border px-2 py-2 rounded overflow-hidden'>
        <div className='grid gap-y-2 md:grid-flow-col gap-x-8 bg-colour2 rounded overflow-hidden p-8'>
          {buttons.map((btn, index) => (
            <Link
              key={index}
              to={btn.link}
              className={`cursor-pointer ${
                index === 0
                  ? 'border-colour6'
                  : index === 1
                  ? 'border-colour7'
                  : index === 2
                  ? 'border-colour8'
                  : index === 3
                  ? 'border-colour5'
                  : ''
              } hover:bg-colour5/50 border-2 border-solid border-colour1 bg-black w-full text-center h-fit px-10 md:px-2 lg:px-6 py-2 rounded mx-auto`}
              aria-label={btn.ariaLabel}
            >
              {btn.text}
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}

export default CallToActionOne;
